export const SNOWPLOW_APP_ID = 'montu-au.umeds-pharmacist';
export const SNOWPLOW_TRACKER_NAME = 'hoc.pharmacist-portal';
